/**
 * 搜索适配器
 * ✅ 完全支持 - 后端搜索API已返回 GameSummary[] + suggestions
 */

import type { GameSummary, SearchParams } from '../api/types';
import type { AdapterResult } from './types';
import { FeatureStatus } from './types';
import { apiClient } from './index';
import { HOT_SEARCH_TERMS } from '../config/fallback-data';

export const searchAdapter = {
  /**
   * 搜索游戏
   * ✅ 完全支持 - 后端返回 games(GameSummary[]) + suggestions
   */
  async search(params: SearchParams): Promise<AdapterResult<{ games: GameSummary[]; total: number; suggestions?: string[] }>> {
    try {
      const response = await apiClient.search(params);
      
      return {
        data: {
          games: response.games ?? [],
          total: response.total,
          suggestions: response.suggestions,
        },
        status: FeatureStatus.AVAILABLE,
      };
    } catch (error) {
      throw error;
    }
  },

  /**
   * 获取搜索建议
   * ✅ 完全支持 - 后端搜索API已返回 suggestions
   */
  async getSuggestions(query: string): Promise<AdapterResult<string[]>> {
    if (!query || query.length < 2) {
      return {
        data: HOT_SEARCH_TERMS.slice(0, 5),
        status: FeatureStatus.DEGRADED,
        message: '热门搜索',
        fallback: true,
      };
    }

    try {
      const response = await apiClient.search({ q: query });
      if (response.suggestions && response.suggestions.length > 0) {
        return {
          data: response.suggestions,
          status: FeatureStatus.AVAILABLE,
        };
      }
    } catch {
      // 降级到本地匹配
    }

    const suggestions = HOT_SEARCH_TERMS
      .filter(term => term.toLowerCase().includes(query.toLowerCase()))
      .slice(0, 5);

    return {
      data: suggestions,
      status: FeatureStatus.DEGRADED,
      message: '本地匹配',
      fallback: true,
    };
  },

  /**
   * 获取热门搜索词
   * ⚠️ 降级 - 使用本地配置
   */
  async getHotSearchTerms(): Promise<AdapterResult<string[]>> {
    return {
      data: HOT_SEARCH_TERMS,
      status: FeatureStatus.DEGRADED,
      message: '热门搜索',
      fallback: true,
    };
  },
};
